import { User } from '../../core/store/user/userSlice';
import Tooltip from '../Tooltip/Tooltip';
import Avatar from './Avatar';
import './Participants.scss';

export type Participant = Pick<User, 'Id' | 'Name' | 'FamilyName'>;

interface Props {
  participants: Participant[];
  className?: string;
}

const collorsMap: { [key: string]: string } = {};

const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');

const pallete = [
  '#3BAEEF',
  '#BB6BD9',
  '#2A2F57',
  '#650B3C',
  '#184A32',
  '#103B90',
  '#8B1887',
  '#1154D6',
  '#0D6751',
  '#250073',
  '#D64C11',
  '#3F9D86',
];

let n = 0;

alphabet.forEach((letter) => {
  if (n >= pallete.length - 1) {
    n = 0;
  }
  collorsMap[letter] = pallete[n];
  n += 1;
});

export const getColor = (str: string) => {
  return collorsMap[str.toLowerCase()[0]] || pallete[0];
};

export default function Participants({ participants, className = '' }: Props) {
  return (
    <div
      className={`d-flex ${className}`}
      style={{
        height: '40px',
        width: 40 + 36 * (participants.length - 1),
      }}
      data-testid='participants'
    >
      {participants.map((p, i: number) => (
        <Tooltip
          key={`participant-${p.Id}`}
          content={
            <>
              {p.Name} {p.FamilyName}
            </>
          }
        >
          <div
            className='position-relative Participants__item'
            style={{
              zIndex: participants.length - i,
              transform: i > 0 ? `translateX(-${4 * i}px)` : undefined,
            }}
            data-testid={`participant-${p.Id}`}
          >
            <Avatar data={p} backgroundColor={getColor(p.Name)} />
          </div>
        </Tooltip>
      ))}
    </div>
  );
}
